<template>
	<div class="container">
		<div class="filter-container">
			<el-input v-model="listQuery.username" :placeholder="langTxt('账号搜索')" style="width: 200px" />
			<el-button type="primary" icon="el-icon-search" @click="handleFilter">{{ langTxt('搜索') }}</el-button>
			<el-button type="success" icon="el-icon-plus" @click="handleEdit()">
				{{ langTxt('添加客服') }}
			</el-button>
		</div>
		<el-table v-loading="listLoading" :data="list" border fit highlight-current-row :height="height">
			<el-table-column show-overflow-tooltip label="GROUPID" prop="group_id"></el-table-column>
			<el-table-column show-overflow-tooltip :label="langTxt('客服名称')" prop="username"></el-table-column>

			<el-table-column show-overflow-tooltip :label="langTxt('客服链接')">
				<template slot-scope="{ row }">
					<el-button type="success" size="mini" icon="el-icon-document-copy" @click="copyLine(row.admin_u_kf.uri)">
						{{ langTxt('复制') }}
					</el-button>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip :label="langTxt('今日点击次数')" prop="report.click_num"> </el-table-column>
			<el-table-column :label="langTxt('状态')" prop="state">
				<template slot-scope="{ row }">
					<el-switch class="switch" v-model="row.state" @change="handleModifyStatus(row, $event)" :active-value="2" :inactive-value="1" active-color="#13ce66" active-text="ON" inactive-text="OFF"> </el-switch>
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip :label="langTxt('备注')" prop="remark"></el-table-column>
			<el-table-column show-overflow-tooltip :label="langTxt('操作')" width="110" class-name="small-padding fixed-width">
				<template slot-scope="{ row }">
					<el-button type="text" size="mini" @click="handleEdit(row)">{{ langTxt('编辑链接') }} </el-button>
					<el-button type="text" v-if="row.group_id != 99" size="mini" @click="handleDelete(row)">{{ langTxt('删除') }} </el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- // 分页 -->
		<pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
		<!--  编辑 -->
		<el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" @close="close">
			<el-form :model="temp" :rules="rules" label-width="80px" :ref="formName">
				<el-form-item :label="langTxt('客服账号')" prop="username">
					<el-input v-model.trim="temp.username" :disabled="readonly"></el-input>
				</el-form-item>

				<el-form-item :label="langTxt('客服链接')" prop="uri">
					<el-input v-model.trim="temp.uri"></el-input>
				</el-form-item>
				<el-form-item v-if="userInfo.group_id == 99" :label="langTxt('权限组')" prop="group_id">
					<el-select v-model.trim="temp.group_id" placeholder="Please select" style="width:100%">
						<el-option key="2" :label="langTxt('代理')" :value="2" />
						<el-option key="1" :label="langTxt('管理')" :value="1" />
						<el-option key="3" :label="langTxt('客服')" :value="3" />
					</el-select>
				</el-form-item>
				<el-form-item v-if="userInfo.group_id == 99" :label="langTxt('登陆密码')" prop="password">
					<el-input v-model.trim="password" :placeholder="langTxt('默认：kf100889')"></el-input>
				</el-form-item>
				<el-form-item v-if="userInfo.group_id == 99" :label="langTxt('备注')" prop="remark">
					<el-input v-model.trim="temp.remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close">{{ langTxt('取消') }}</el-button>
				<el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">
					{{ langTxt('保存') }}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'KfAdminUList',

		data() {
			return {
				list: null,
				formName: 'banner',
				listLoading: true,
				temp: {},
				dialogFormVisible: false,
				dialogStatus: '',
				password: '',
				readonly: false,
				textMap: {
					update: 'Edit',
					create: 'Create'
				},
				listQuery: {
					page: 1,
					pagesize: 20,
					group_id: 3
				},
				total: 0,
				rules: {
					username: [
						{
							required: true,
							message: 'username is required',
							trigger: 'blur'
						}
					]
				},
				// eslint-disable-next-line vue/no-reserved-keys
				__i18n: {}
			};
		},
		computed: {
			height() {
				return this.$baseTableHeight();
			},
			userInfo() {
				if (sessionStorage.getItem('admin-info')) return JSON.parse(sessionStorage.getItem('admin-info'));
				return null;
			}
		},

		created() {
			this.getList();
			this.__i18n = this.$i18n.messages[this._i18n.locale];
		},
		methods: {
			// 搜索
			handleFilter() {
				this.listQuery.page = 1;
				this.getList();
			},
			// 获取列表
			getList() {
				this.listLoading = true;
				this.request
					.get('/admin-u', {
						params: this.listQuery
					})
					.then((ret) => {
						this.list = ret.list;
						this.total = ret.count;
						setTimeout(() => {
							this.listLoading = false;
						}, 200);
					});
			},
			// 添加、修改
			handleEdit(row) {
				if (this.$refs[this.formName]) {
					this.$refs[this.formName].resetFields();
				}
				if (!row) {
					this.dialogStatus = 'create';
					this.readonly = false;
					this.temp.state = 2; // ok
				} else {
					this.dialogStatus = 'update';
					this.temp = Object.assign({}, row);
					this.readonly = true;
					this.$set(this.temp, 'uri', this.temp.admin_u_kf.uri);
				}
				this.dialogFormVisible = true;
			},

			close() {
				this.dialogFormVisible = false;
			},

			// 修改状态  /admin-edit
			handleModifyStatus(row, status) {
				let postData = {
					id: row.id,
					state: status,
					uri: row.admin_u_kf.uri
				};
				this.request
					.post('/admin-edit', postData)
					.then(() => {
						row.state = status;
						this.$message.success(this.__i18n.common.stateSuccess);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 提交表单
			updateData() {
				this.$refs[this.formName].validate((valid) => {
					if (valid) {
						var postData = {
							id: this.temp.id,
							uri: this.temp.uri,
							state: this.temp.state,
							remark: this.temp.remark
						};
						if (this.password) {
							postData.password = this.password;
						}
						this.request
							.post('/admin-edit', postData)
							.then(() => {
								this.$message.success(this.__i18n.common.editSuccess);
								this.getList();
								this.close();
							})
							.catch((err) => {
								console.log(err);
							});
					}
				});
			},
			handleDelete(row) {
				this.$confirm(this.langTxt('确认删除客服?'), this.langTxt('删除客服'), {
					confirmButtonText: this.langTxt('确认'),
					cancelButtonText: this.langTxt('取消'),
					type: 'warning'
				})
					.then(() => {
						var postData = {
							id: row.id
						};
						this.request.post('/admin-remove', postData).then(() => {
							this.$message.success(this.langTxt('删除成功'));
							const index = this.list.findIndex((v) => v.id === row.id);
							this.list.splice(index, 1);
						});
					})
					.catch(() => {});
			},
			// 创建
			createData() {
				this.$refs[this.formName].validate((valid) => {
					if (valid) {
						if (!this.password) {
							this.temp.password = 'kf100889';
						} else {
							this.temp.password = this.password;
						}
						this.request.post('/admin-add', this.temp).then(() => {
							this.$message.success(this.__i18n.common.addSuccess);
							this.getList();
							this.close();
						});
					}
				});
			},

			// 复制推广链接
			copyLine(link) {
				console.log(link);
				this.$copyText(link).then(
					() => {
						this.$message({
							message: this.langTxt('复制成功'), //"复制成功"
							type: 'success'
						});
					},
					() => {
						this.$message.error(this.langTxt('复制失败')); //"复制失败"
					}
				);
			}
		}
	};
</script>
